export default "__VITE_ASSET__fpdwk9DZ__"